import * as React from 'react';

export const IconTail = () => {
  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="12" height="19" viewBox="0 0 12 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 18.8638C7.0848 19.6581 1.57538 16.8153 0 14.9952C1.62379 10.9282 6 -0.000227451 6 -0.000227451C6 10.4242 7 14.5005 12 18.8638Z"
        fill="currentColor"
      />
    </svg>
  );
};
